import initialState from "./initialState";

export function SearchCategorizationReducer(
  state = initialState.SearchCategorization,
  action
) {
  switch (action.type) {
    
    case "SEARCH_CATEGORIZATION_SELECTION_REQUEST":
      return {
        ...state,
        searchType: action.payload,
      };
    default:
      return state;
  }
}
